<app-base-page-template>
  <app-base-page-content-template>
    <app-reconciliation-grid
      (dataLoaded)="onDataLoaded($event)"
      (rowClick)="onRowClicked($event)"
      (addButtonClick)="onAddButtonClicked()">
    </app-reconciliation-grid>
  </app-base-page-content-template>
</app-base-page-template>
